import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=c51221a0&"
import script from "./Composer.vue?vue&type=script&lang=js&"
export * from "./Composer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51221a0')) {
      api.createRecord('c51221a0', component.options)
    } else {
      api.reload('c51221a0', component.options)
    }
    module.hot.accept("./Composer.vue?vue&type=template&id=c51221a0&", function () {
      api.rerender('c51221a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/Composer.vue"
export default component.exports